import basic from '@/views/product/views/basic/basic'
export default basic;